import { FACE_MESH_INDEX_BUFFER, FACE_MESH_UV } from './face_geom.js';
import * as THREE from 'three';
import { GLTFExporter } from 'gltf-exporter';

//import { Environment } from './environment.js';

export class FaceGeo {
  constructor(scene, settings, width, height, environment, materialManager, postprocess, textures) {
    this.postprocess = postprocess;
    this.faceGEO = null;
    this.geometry = new THREE.BufferGeometry();
    this.scene = scene;
    this.settings = settings;

    this.materialManager = materialManager; // Store the material manager reference
    //this.canvas = canvas;
    //this.videoCanvas = videoCanvas;

    this.useScreenSpace = false;
    this.width = width;
    this.height = height;
    this.visible = false;
    this.needEasing = true;
    this.texturesLoaded = false;
    this.environment = environment;
    this.firstAppearance = false;
    this.texture = null
    //= new THREE.CanvasTexture(videoCanvas);
    this.uvMat = this.createUVMaterial();
    this.textures = textures;

    if (this.textures?.textureMap || this.textures?.alphaMap || this.textures?.roughnessMap || this.textures?.emissiveMap || this.textures?.normalMap) {
      this.loadTextures().then(() => {
        // console.log('✅ Textures FaceGeo chargées avec succès');
        this.texturesLoaded = true;
      }).catch(error => {
        console.error('❌ Erreur lors du chargement des textures FaceGeo:', error);
      });
    } else {
      console.warn('⚠️ Pas de textures définies pour FaceGeo');
      this.texturesLoaded = true; // On considère qu'il n'y a pas besoin d'attendre
    }

    // Stocker la référence bindée pour pouvoir la supprimer dans dispose()
    this._boundExportGLTF = this.exportGLTF.bind(this);
    window.addEventListener('keydown', this._boundExportGLTF);

    // Pool pour éviter les allocations répétées
    this.vertexPool = new Float32Array(468 * 3);
    this.tempVector = new THREE.Vector3();
  }

  async loadTextures() {
    window.loader.setMessage('Chargement des Textures');


    const loader = new THREE.TextureLoader();
    try {
      if (this.textures.textureMap) {
        this.faceTextureMap = await loader.loadAsync(this.textures.textureMap);
        this.faceTextureMap.flipY = false;

        this.uvMat.map = this.faceTextureMap;
        this.uvMat.map.colorSpace = THREE.SRGBColorSpace;
        // this.uvMat.map.magFilter = THREE.NearestFilter;
        // this.uvMat.map.minFilter = THREE.NearestFilter;

      }

      if (this.textures.roughnessMap) {
        this.faceRoughnessMap = await loader.loadAsync(this.textures.roughnessMap);
        this.faceRoughnessMap.flipY = false;

        this.uvMat.roughnessMap = this.faceRoughnessMap;
        this.uvMat.roughnessMap.colorSpace = THREE.SRGBColorSpace;

      }

      if (this.textures.roughness) {
        this.uvMat.roughness = this.textures.roughness; // Set roughness directly if provided
      }

      if (this.textures.emissiveMap) {
        this.faceEmissiveMap = await loader.loadAsync(this.textures.emissiveMap);
        this.faceEmissiveMap.flipY = false;
        this.uvMat.emissive = new THREE.Color(1, 1, 1); // Set emissive color to white
        this.uvMat.emissiveMap = this.faceEmissiveMap;
        this.uvMat.emissiveMap.colorSpace = THREE.SRGBColorSpace;
      }

      if (this.textures.normalMap) {
        this.faceNormalMap = await loader.loadAsync(this.textures.normalMap);
        this.faceNormalMap.flipY = false;
        this.uvMat.normalMap = this.faceNormalMap;
        this.uvMat.normalMap.colorSpace = THREE.SRGBColorSpace;
        this.uvMat.normalScale = new THREE.Vector2(0.5, 0.5); // Set normal scale to 1
      }


      if (this.textures.alphaMap) {
        this.faceAlphaMap = await loader.loadAsync(this.textures.alphaMap);
        this.faceAlphaMap.flipY = false;

        this.uvMat.alphaMap = this.faceAlphaMap;
        this.uvMat.alphaMap.colorSpace = THREE.SRGBColorSpace;
        // this.uvMat.alphaMap.magFilter = THREE.NearestFilter;
        // this.uvMat.alphaMap.minFilter = THREE.NearestFilter;

      }

      this.uvMat.emissiveIntensity = 10.0;

      this.uvMat.needsUpdate = true;
      this.uvMat.opacity = 0;
      //  console.log(this.uvMat)
    } catch (error) {
      console.error('Error loading textures', error);
    }
  }

  createUVMaterial() {
    return new THREE.MeshStandardMaterial({
      color: "#FFFFFF",

      depthWrite: false,
      transparent: true,
    });
  }

  detectedUpdate(scene, fixedKeypoints, width, height) {
    this.width = width;
    this.height = height;
    this.scene = scene;

    // Réutiliser le pool au lieu de créer un nouveau tableau
    for (let i = 0; i < 468; i++) {
      const point = fixedKeypoints[i];
      const idx = i * 3;
      this.vertexPool[idx] = point.x;
      this.vertexPool[idx + 1] = point.y;
      this.vertexPool[idx + 2] = point.z;
    }

    if (this.texturesLoaded) {
      if (!this.faceGEO) {
        this.geometry = this.makeGeometry(fixedKeypoints);
        this.faceGEO = new THREE.Mesh(this.geometry, this.uvMat);
        this.faceGEO.name = "faceGeo";
        this.faceGEO.visible = false; // Invisible par défaut
        this.scene.add(this.faceGEO);

        if (!this.firstAppearance) {
          if (this.environment) {
            this.environment.updateEnvironmentMap();
          }
          this.firstAppearance = true;
        }
      } else if (this.faceGEO.geometry && this.faceGEO.geometry.attributes.position) {


        if (this.faceGEO.visible == true && this.needEasing) {
          gsap.killTweensOf(this.uvMat);
          this.uvMat.opacity = 0;


          this.needEasing = false;



          gsap.to(this.uvMat, {
            opacity: 1,
            duration: 5, // durée en secondes
            ease: "power2.out",

          });
          this.uvMat.needsUpdate = true;

        }
        else if (this.faceGEO.visible == false && !this.needEasing) {
          gsap.killTweensOf(this.uvMat);
          this.uvMat.opacity = 0;
         // console.log(this.uvMat)
          this.needEasing = true;
        }
        // Optimisation : éviter computeVertexNormals à chaque frame
        this.faceGEO.geometry.attributes.position.array.set(this.vertexPool);
        this.faceGEO.geometry.attributes.position.needsUpdate = true;

        // Calculer les normales seulement toutes les 5 frames
        if (!this.normalUpdateCounter) this.normalUpdateCounter = 0;
        if (this.normalUpdateCounter++ % 5 === 0) {
          this.faceGEO.geometry.computeVertexNormals();
        }
      }
    }
  }


  makeGeometry(landmarks) {
    let vertices = [];
    let uvs = [];
    let geometry = new THREE.BufferGeometry();

    for (let i = 0; i < 468; i++) {
      let { x, y, z } = landmarks[i];
      vertices.push(x, y, z);
    }

    for (let j = 0; j < 468; j++) {
      uvs[j * 2] = FACE_MESH_UV[j][0];
      uvs[j * 2 + 1] = FACE_MESH_UV[j][1];
    }

    geometry.setIndex(FACE_MESH_INDEX_BUFFER);
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
    geometry.computeVertexNormals();
    return geometry;
  }

  exportGLTF(event) {
    if (event.key === 'e') {
      const exporter = new GLTFExporter();
      exporter.parse(this.scene, (gltf) => {
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        const blob = new Blob([JSON.stringify(gltf)], { type: 'application/json' });
        link.href = URL.createObjectURL(blob);
        link.download = 'face_mask.gltf';
        link.click();
      }, (error) => {
        console.error('An error happened during export', error);
      });
    }
  }

  faceAppear() {
    if (this.faceGEO) {
      this.faceGEO.visible = true;


    }
  }

  faceDisappear() {
    if (this.faceGEO) {
      this.faceGEO.visible = false;
    }
  }

  debugVisualPoints(scene) {
    if (this.geometry && this.geometry.attributes.position) {
      const vertices = this.geometry.attributes.position.array;
      const debugGroup = new THREE.Group();
      debugGroup.name = "debugPoints";

      for (let i = 0; i < vertices.length; i += 3) {
        const sphereGeometry = new THREE.SphereGeometry(0.5, 8, 8);
        const sphereMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
        sphere.position.set(vertices[i], vertices[i + 1], vertices[i + 2]);
        debugGroup.add(sphere);
      }

      // Remove previous debug points if they exist
      const existingDebugGroup = scene.getObjectByName("debugPoints");
      if (existingDebugGroup) {
        scene.remove(existingDebugGroup);
      }

      scene.add(debugGroup);
    } else {
      console.log("No geometry data available for visual debugging.");
    }
  }

  /**
   * Nettoyage des ressources pour éviter les memory leaks
   */
  dispose() {
    // Supprimer l'event listener (utiliser la référence bindée stockée)
    if (this._boundExportGLTF) {
      window.removeEventListener('keydown', this._boundExportGLTF);
      this._boundExportGLTF = null;
    }

    // Retirer de la scène
    if (this.scene && this.faceGEO) {
      this.scene.remove(this.faceGEO);
    }

    // Disposer de la géométrie
    if (this.geometry) {
      this.geometry.dispose();
      this.geometry = null;
    }

    // Disposer des textures chargées
    if (this.faceTextureMap) {
      this.faceTextureMap.dispose();
      this.faceTextureMap = null;
    }
    if (this.faceAlphaMap) {
      this.faceAlphaMap.dispose();
      this.faceAlphaMap = null;
    }
    if (this.faceRoughnessMap) {
      this.faceRoughnessMap.dispose();
      this.faceRoughnessMap = null;
    }
    if (this.faceEmissiveMap) {
      this.faceEmissiveMap.dispose();
      this.faceEmissiveMap = null;
    }
    if (this.faceNormalMap) {
      this.faceNormalMap.dispose();
      this.faceNormalMap = null;
    }

    // Disposer du matériau
    if (this.uvMat) {
      if (this.uvMat.map) this.uvMat.map.dispose();
      if (this.uvMat.alphaMap) this.uvMat.alphaMap.dispose();
      if (this.uvMat.roughnessMap) this.uvMat.roughnessMap.dispose();
      if (this.uvMat.emissiveMap) this.uvMat.emissiveMap.dispose();
      if (this.uvMat.normalMap) this.uvMat.normalMap.dispose();
      this.uvMat.dispose();
      this.uvMat = null;
    }

    this.faceGEO = null;
    this.texture = null;
  }
}

// Utilisation de window.loader pour mettre à jour le texte de chargement
